'use strict';
module.exports = function linearBackoff() {
	let calls = 0;
	return function () {
		calls = calls + 1;
		return 1000 * calls;
	};
};
